'use es6';

let _ = t => t,
  _t,
  _t2;
import { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../theming/themes/colors';
import websitePerformanceRating from 'bender-url!../../../img/website-performance-rating.jpg';
import { TabletAndBelow } from '../../theming/themes/mixins';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledAccordion = styled.div.withConfig({
  displayName: "BottomFaq__StyledAccordion",
  componentId: "hhajes-0"
})(["border:1px solid ", ";margin-bottom:1.2rem;.question{line-height:20px;margin-bottom:0;position:relative;font-family:var(--web-font-family);font-size:1.1rem;font-weight:600;cursor:pointer;padding:1.75rem 1.75rem 1.75rem 3rem;}.question::before{transform:", ";border-style:solid;border-width:1px 1px 0 0;content:' ';display:inline-block;position:absolute;top:45%;left:1.5rem;transition:0.25s ease-in-out;vertical-align:top;width:10px;height:10px;}.answer{display:", ";font-size:0.875rem;font-weight:300;line-height:1.75;padding:0 3.5rem 2rem;}"], colors.LIGHTGREYBORDER, props => props.open ? 'rotate(135deg)' : 'rotate(45deg)', props => props.open ? 'inline-block' : 'none');
const BottomFaqWrapper = styled.div.withConfig({
  displayName: "BottomFaq__BottomFaqWrapper",
  componentId: "hhajes-1"
})(["background-color:", ";color:", ";width:100%;text-align:start;font-family:var(--web-font-family);"], colors.PRIMARYWHITE, colors.DARKTEXT);
const OverviewSection = styled.section.withConfig({
  displayName: "BottomFaq__OverviewSection",
  componentId: "hhajes-2"
})(["margin:5rem auto;max-width:1000px;display:flex;flex-direction:row;justify-content:space-around;padding:0 1rem;.overview{width:45%;}h2.overview-title{font-family:var(--web-font-family);font-size:2rem;font-weight:600;line-height:1.38;letter-spacing:0;text-transform:none;text-align:start;padding:1rem 0;}p.overview-description{font-size:1rem;font-weight:300;line-height:1.75;padding:1.5rem 0;}.overview-img{width:45%;img{height:auto;width:100%;}}", ""], TabletAndBelow(_t || (_t = _`
    flex-direction: column-reverse;

    .overview {
      width: 100%;
    }

    .overview-img {
      height: auto;
      width: 100%;
    }
  `)));
const QuestionsSection = styled.section.withConfig({
  displayName: "BottomFaq__QuestionsSection",
  componentId: "hhajes-3"
})(["background-color:", ";padding:3rem 0;.questions-center-wrapper{max-width:1000px;margin:0 auto;h2.questions-title{font-family:var(--web-font-family);font-size:1.625rem;font-weight:600;letter-spacing:0;text-transform:none;padding-bottom:1rem;}.questions{display:flex;flex-wrap:wrap;justify-content:space-around;}.questions-col{width:48%;padding:0 1rem;", "}}"], colors.MEDIUMGREYBACKGROUND, TabletAndBelow(_t2 || (_t2 = _`
        width: 100%;
      `)));
const Accordion = ({
  question,
  answer
}) => {
  const [open, setOpen] = useState(false);
  const handleClick = e => {
    e.stopPropagation();
    setOpen(!open);
  };
  return /*#__PURE__*/_jsxs(StyledAccordion, {
    open: open,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx("h3", {
      className: "question",
      children: question
    }), /*#__PURE__*/_jsx("article", {
      className: "answer",
      children: answer
    })]
  });
};
const BottomFaq = () => {
  return /*#__PURE__*/_jsxs(BottomFaqWrapper, {
    children: [/*#__PURE__*/_jsxs(OverviewSection, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "overview",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "overview-title",
          children: "Instant Website Performance Audit for Google Search and AI Search Engines"
        }), /*#__PURE__*/_jsx("p", {
          className: "overview-description",
          children: "HubSpot's free Website Grader analyzes your site's performance across 17+ key metrics in under 30 seconds, providing actionable recommendations to improve visibility in Google search. This free SEO website analyzer eliminates guesswork by delivering comprehensive performance scores and recommendations for site speed optimization, mobile-first compatibility, security vulnerability assessment, and search engine optimization\u2014delivered instantly without technical expertise or software installation required."
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "overview-img",
        children: /*#__PURE__*/_jsx("img", {
          loading: "lazy",
          height: "462px",
          width: "470px",
          src: websitePerformanceRating,
          alt: "Webpage score after performing a free test with the Website Grader"
        })
      })]
    }), /*#__PURE__*/_jsx(QuestionsSection, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "questions-center-wrapper",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "questions-title",
          children: "More Information"
        }), /*#__PURE__*/_jsxs("div", {
          className: "questions",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "questions-col",
            children: [/*#__PURE__*/_jsx(Accordion, {
              question: "What is a website SEO checker?",
              answer: /*#__PURE__*/_jsx("p", {
                children: "A website checker is an AI SEO checker tool that analyzes your site's technical performance, SEO implementation, mobile optimization, and security protocols across ranking factors. HubSpot's Website Ranker crawls your site infrastructure to access Core Web Vitals metrics and security configurations that provide comprehensive insights into your website's health and optimization opportunities. Check your website SEO instantly, for free."
              })
            }), /*#__PURE__*/_jsx(Accordion, {
              question: "Why is website performance important?",
              answer: /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("p", {
                  children: "Website performance directly impacts both user retention and search engine rankings through measurable speed and interactivity metrics. Sites with loading times under a few seconds maintain higher user engagement rates, while pages taking longer to load experience higher bounce rates. Users expect immediate responses for clicks, form submissions, and page navigation; delays significantly reduce conversion probability."
                }), /*#__PURE__*/_jsx("p", {
                  children: "Higher speed also makes your site more attractive to search engines. Search engines prioritize fast-loading websites because site speed directly correlates with user satisfaction metrics that Google uses as ranking factors. Websites with optimized performance demonstrate lower bounce rates, longer session durations, and higher engagement rates\u2013 signals that search algorithms interpret as indicators of content quality and user value."
                }), /*#__PURE__*/_jsx("p", {
                  children: "This creates a performance-driven growth cycle: improved site speed leads to better user experience metrics, which results in higher search rankings, generating increased organic traffic from users with stronger purchase intent, ultimately delivering improved conversion rates and sustainable business growth. Get a free website analysis to improve your website performance today."
                })]
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "questions-col",
            children: [/*#__PURE__*/_jsx(Accordion, {
              question: "How to optimize a website for SEO?",
              answer: /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("p", {
                  children: "Effective SEO optimization follows a systematic approach starting with technical foundations and expanding to content optimization. Begin by ensuring search engines can crawl and index your pages. Implement comprehensive meta titles and descriptions for every page, add descriptive alt text to all images, and create clear internal linking with keyword-rich anchor text."
                }), /*#__PURE__*/_jsx("p", {
                  children: "Advanced SEO optimization includes structured data markup implementation, page speed optimization for Core Web Vitals compliance, and mobile-first responsive design. Content optimization requires header tag hierarchy (H1-H6), keyword integration in titles and headings, and comprehensive topic coverage that addresses user search intent."
                }), /*#__PURE__*/_jsxs("p", {
                  children: [/*#__PURE__*/_jsx("strong", {
                    children: "Assessment-First Strategy:"
                  }), " Before implementing changes, use a SEO page grader to analyze your website and identify specific improvement opportunities. HubSpot\u2019s Website Grader provides a free website audit covering all parts of SEO: technical foundations, on-page optimization, and mobile performance. Putting your website through a SEO report card tool provides a baseline for measuring optimization progress and prioritizing high-impact improvements."]
                }), /*#__PURE__*/_jsxs("p", {
                  children: ["To learn more about the factors that are playing into your website SEO health, check out HubSpot Academy\u2019s", ' ', /*#__PURE__*/_jsx("a", {
                    href: "https://academy.hubspot.com/courses/web-optimization",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "Web Optimization Course"
                  }), "."]
                })]
              })
            }), /*#__PURE__*/_jsx(Accordion, {
              question: "Why is website grading important?",
              answer: /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("p", {
                  children: "Website grading provides objective performance benchmarking against industry standards and competitive analysis that informs strategic optimization decisions. Regular performance auditing identifies technical issues that reduce search visibility, discovers optimization opportunities that improve user experience and rankings simultaneously, and provides competitive intelligence about industry performance standards."
                }), /*#__PURE__*/_jsx("p", {
                  children: "Uncover optimization opportunities with quantified impact potential and establish baseline metrics for measuring improvement progress over time. Use HubSpot\u2019s Website Analysis SEO tool to check a website\u2019s SEO today."
                })]
              })
            })]
          })]
        })]
      })
    })]
  });
};
export default BottomFaq;